import "core-js/modules/es.array.push.js";
// import { UploadFilled } from '@element-plus/icons-vue';
import ParamForm from './ParamForm.vue';
import FileItem from './FileItem.vue';
import { downloadBatch } from '../utils';
import { config } from '../config';
import { acceptImageFormats } from '../config/index';
import ImgAddLogo from './ImgAddLogo.vue';
import ImgRotate from './ImgRotate.vue';
import ImgScale from './ImgScale.vue';
export default {
  components: {
    // UploadFilled,
    ParamForm,
    FileItem,
    ImgAddLogo,
    ImgRotate,
    ImgScale
  },
  data() {
    return {
      radioA: '1',
      acceptImageFormats,
      baseUrl: config.baseUrl,
      fileList: [],
      options: {
        quality: 75,
        format: '',
        divide: 3,
        cdn: false,
        cdnDir: ''
      },
      isMobile: false
    };
  },
  computed: {
    uploadOptions() {
      const {
        quality,
        format,
        cdn,
        divide,
        cdnDir
      } = this.options;
      return {
        quality: quality,
        format: format,
        cdn: cdn || '',
        divide: divide >= 2 ? divide : 0,
        cdnDir
      };
    }
  },
  mounted() {
    // 检测设备类型
    this.checkDeviceType();
    // 监听窗口大小变化
    window.addEventListener('resize', this.checkDeviceType);
  },
  beforeUnmount() {
    // 移除事件监听
    window.removeEventListener('resize', this.checkDeviceType);
  },
  methods: {
    // 检测设备类型
    checkDeviceType() {
      this.isMobile = window.innerWidth <= 768;
    },
    downloadAll() {
      const list = [];
      for (let idx = 0; idx < this.fileList.length; idx++) {
        const item = this.fileList[idx];
        if (item?.response?.data?.images) {
          item.response.data.images.forEach(i => {
            list.push(i);
          });
        }
      }
      if (list.length) {
        downloadBatch(list);
      }
    },
    clearFileList() {
      this.fileList = [];
    }
  }
};